import {
  GET_LICENSES_REQUEST,
  GET_LICENSES_SUCCESS,
  GET_LICENSES_FAILURE,
  GET_TRACK_USAGE_REQUEST,
  GET_TRACK_USAGE_SUCCESS,
  GET_TRACK_USAGE_FAILURE,
} from '../constants/settingConstants';

export const getLicenses = (params) => ({
  type: GET_LICENSES_REQUEST,
  payload: params,
});

export const getLicensesSuccess = (data) => ({
  type: GET_LICENSES_SUCCESS,
  payload: data,
});

export const getLicensesFailure = (error) => ({
  type: GET_LICENSES_FAILURE,
  payload: error,
});

export const getTrackUsage = (params) => ({
  type: GET_TRACK_USAGE_REQUEST,
  payload: params,
});

export const getTrackUsageSuccess = (data) => ({
  type: GET_TRACK_USAGE_SUCCESS,
  payload: data,
});

export const getTrackUsageFailure = (error) => ({
  type: GET_TRACK_USAGE_FAILURE,
  payload: error,
});